import { initBackgroundCanvas } from './handleCanvas.js'
import { hasAttr, isTouchScreen } from '../helpers/helpers.js'
import { initCodeTicker } from './handleCodeTicker.js'
import handleSettingsPopup from './handleSettingsPopup.js'
import { initTheme } from '../helpers/preferences.js'
import { initWaitingList } from './handleWaitingList.js'
import { initAnalyticsConsent } from './handleAnalyticsConsent.js'

const isFrontPage = hasAttr(document.body, 'data-front-page')

export default function setFrontPage() {
	initTheme()
	handleSettingsPopup()
	initWaitingList()
	initAnalyticsConsent()
	if (!isFrontPage) {
		return
	}
	initCodeTicker()
	if (!isTouchScreen()) {
		initBackgroundCanvas()
	}
}
